import Action from "../base/action";

class ExplodeModel extends Action {
    unit;

    constructor(props) {
        super(props);
        this.model = props.model;
        this.unit = props.unit;
    }

    async execute({training}) {
        explodeModel(this.unit, training.resources[this.model.id].resourceId);
    }
}

export default ExplodeModel;